<template>
    <div>
        <div class="pb-2 pt-5">
            <p class="profile__container--content__orderhistory--details-price__title mb-0">Produkter</p>
        </div>

        <div class="pb-5 pickup-location">
            <p class="mb-0"><b>Hentes hos</b></p>
            <p class="pickup-location__text">{{order.salonInformation.siteName}}</p>
            <p class="pickup-location__text">{{order.salonInformation.address}}</p>
            <p class="pickup-location__text">{{order.salonInformation.postalCode + ' ' + order.salonInformation.area}}</p>
            <p class="pickup-location__text">Org.nr. {{order.salonInformation.organizationNumber}}</p>
        </div>

        <div v-for="product in productsOrder" :key="product.id">
            <div class="d-flex align-center justify-space-between mb-5">
                <div class="d-flex align-center">
                    <v-img class="mr-2" width="48" height="48" :src="product.imageUrl"></v-img>
                    <div class="profile__container--content__orderhistory--details">
                        <p class="font-weight-bold">{{product.name}}</p>
                        <p>{{product.brandName}}</p>
                        <p :style="price(product).total != (product.price * product.quantity) ? 'color: red' : ''">{{product.discounts.length ? discount(product).discountText : ''}}</p>
                    </div>
                </div>
                <div class="d-flex">
                    <div v-if="product.quantity">
                        <div class="profile__container--content__orderhistory--details font-weight-bold">
                            <p>Pr. enhet</p>
                        </div>
                        <div :class="isCancelled ? 'text-decoration-line-through' : ''">
                            {{price(product).unit.toFixed(2).replace('.', ',')}}
                        </div>
                    </div>
                    <div class="pl-5">
                        <div class="profile__container--content__orderhistory--details font-weight-bold">
                            <p>Antall</p>
                        </div>
                        <div class="d-flex justify-center" :class="isCancelled ? 'text-decoration-line-through' : ''">
                            {{product.quantity}}
                        </div>
                    </div>
                    <div class="profile__container--content__orderhistory--details-price font-weight-bold pl-10 text-end" style="width: 100px" :class="isCancelled ? 'text-decoration-line-through' : ''">
                        <p class="mb-0 text-decoration-line-through " style="font-size: 14px; text-align: right" v-show="price(product).total != (product.price * product.quantity)">{{(product.price * product.quantity).toFixed(2).replace('.', ',')}}</p>
                        <p class="mb-0 text-decoration-line-through " style="line-height: 14px; text-align: right; display: block; height: 1em" v-show="price(product).total == (product.price * product.quantity)"></p>
                        <p :style="price(product).total != (product.price * product.quantity) ? 'color: red' : ''" class="mb-0">{{price(product).total.toFixed(2).replace('.', ',')}}</p>
                    </div>
                </div>
            </div>
        </div>

        <hr class="profile__container--content__orderhistory--producthistory__linebreak mb-3"/>
        <div class="d-flex align-center justify-space-between">
            <div>
                <p class="mb-0 profile__container--content__orderhistory--details-price__title">Sum produkter</p>
            </div>
            <div class="profile__container--content__orderhistory--details-price">
                <p class="mb-0 font-weight-bold" :class="isCancelled ? 'text-decoration-line-through' : ''">{{productsTotalPrice.toFixed(2).replace('.', ',')}}</p>
            </div>
        </div>
        <p v-if="!order.treatments.length && order.paymentMethod && order.orderHistoryType !== 'cancelled'" class="mt-4"><b>Betalingsmetode:</b> {{order.paymentMethod}}</p>
    </div>
</template>

<script>
export default {
    props: {
        order: {
            required: true,
            default: {},
            type: Object
        },
        layout: {
            required: false,
            default: 'chain',
            type: String
        }
    },
    computed: {
        productsOrder() {
            return this.order.products
        },
        productsTotalPrice() {
            return this.order.products.reduce((partialSum, a) => {return partialSum + this.price(a).total}, 0)
        },
        isCancelled() {
            return this.order.orderHistoryType === 'cancelled'
        }
    },
    methods: {
        getDate(appointmentDate) {
            return new Date(appointmentDate).toLocaleDateString("no-NO", { year: 'numeric', month: 'long', day: 'numeric' })
        },
        getTime(appointmentDate) {
            return new Date(appointmentDate).toLocaleTimeString("no-NO", { hour: "2-digit", minute: "2-digit" })
        },
        calculateAndGetVat(totalPrice) {
            return (((totalPrice / 1.25) - totalPrice) * -1).toFixed(2)
        },
        // redirectProduct() {
        //     this.$emit('close-profile')
        //     this.layout == 'portal' ? window.open(`${process.env.VUE_APP_FIXIT_NO_URL}/frisor/${this.order.urlSafeSiteName}/${this.order.siteId}`, '_self') : this.$router.push(`/about/${this.order.urlSafeSiteName}/${this.order.siteId}`)
        // },
        // redirectSalon() {
        //     this.layout == 'portal' ? window.open(`${process.env.VUE_APP_FIXIT_NO_URL}/frisor/${this.order.urlSafeSiteName}/${this.order.siteId}`, '_self') : this.$router.push(`/about/${this.order.urlSafeSiteName}/${this.order.siteId}`)
        // },
        discount(product) {
            let lowestDiscountPrice = Math.min(product.discounts.map(x => x.discountPrice))
            return product.discounts.find(x => x.discountPrice === lowestDiscountPrice)
        },
        price(product){
            const quantity = product.quantity
            const originalPrice = product.price
            const hasDiscounts = product.discounts.length > 0
            const productsDiscounted = hasDiscounts ? product.discounts.reduce((partialSum, d) => {return partialSum + d.quantity}, 0) : 0
            if(productsDiscounted > 0){
                if(productsDiscounted === quantity){
                    return {
                        unit: product.discounts.reduce((partialSum, d) => {return partialSum + (d.quantity * d.discountPrice)}, 0) / quantity,
                        total: product.discounts.reduce((partialSum, d) => {return partialSum + (d.quantity * d.discountPrice)}, 0)
                    } 
                }
                if(productsDiscounted < quantity){
                    return {
                        unit: (((quantity - productsDiscounted)*originalPrice) + product.discounts.reduce((partialSum, d) => {return partialSum + (d.quantity * d.discountPrice)}, 0)) / quantity,
                        total: (((quantity - productsDiscounted)*originalPrice) + product.discounts.reduce((partialSum, d) => {return partialSum + (d.quantity * d.discountPrice)}, 0))
                    }
                }
            }
            else {
                return {
                    unit: originalPrice,
                    total: quantity*originalPrice
                }
            }
        }

    }
}
</script>

<style scoped lang="scss">
.pickup-location {
    &__text {
        margin-bottom: 0px;
        font-size: 14px;
        line-height: 16px;
    }
}
</style>